import { CalendarPage } from '@agentic-flow-studio/shared/components/calendar/CalendarPage';
import { useWorkspaceMembers } from '@/hooks/useHarbor';

export default function Calendar() {
  const { data: members = [] } = useWorkspaceMembers();
  return <CalendarPage workspaceMembers={members} />;
}
